/**
 * Format NDC with hyphens (12345-234-23 format)
 * Shared across all templates.
 */
export const formatNDC = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 5) return numbers;
  if (numbers.length <= 8) return `${numbers.slice(0, 5)}-${numbers.slice(5)}`;
  return `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}-${numbers.slice(8, 10)}`;
};
